import axios from "axios"

export const apiPublicFetch = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
})
